import React from 'react';
import Helmet from 'react-helmet';
import PropTypes from 'prop-types';
import { Header, SocialMedia } from 'components';
import { Layout, Container } from 'layouts';
import { Link } from 'gatsby';

const About = center => (
  <Layout>
    <Helmet title={'Contact US'} />
    <Header title="Contact US">Find US at Facebook Instgram and Twitter</Header>
    <Container center={center}>
      <SocialMedia/>
    </Container>
  </Layout>
);

export default About;

Container.propTypes = {
  center: PropTypes.object,
};
